// extracted by mini-css-extract-plugin
export default {"tab":"tab__H6_Br"};
    if(module.hot) {
      // 1790586312489
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  